import styled from 'styled-components'

export const StyledJATOCookie = styled.div``
